import { Map } from 'immutable';

export default function getSliceItems(slice: any) {
  return (state: any) => state.getIn([slice, 'data', 'byId'], Map());
}
